export default "__VITE_ASSET__DmHhYReQ__"